import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "dweb-header-v2" */ './Header'));
